import { render, staticRenderFns } from "./subject.vue?vue&type=template&id=fadeb61c&scoped=true"
import script from "./subject.vue?vue&type=script&lang=js"
export * from "./subject.vue?vue&type=script&lang=js"
import style0 from "./subject.vue?vue&type=style&index=0&id=fadeb61c&prod&lang=scss"
import style1 from "./subject.vue?vue&type=style&index=1&id=fadeb61c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fadeb61c",
  null
  
)

export default component.exports